export function initGA() {
    if (typeof window.gtag === 'undefined') {
        const script = document.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=G-42P35YG3WW`;
        script.async = true;
        document.head.appendChild(script);

        // Initialiser Google Analytics après le chargement du script
        script.onload = () => {
            window.dataLayer = window.dataLayer || [];
            function gtag() {
                window.dataLayer.push(arguments);
            }
            gtag('js', new Date());
            gtag('config', 'G-42P35YG3WW');
        };
    }
}
